import { z } from 'zod';

const runtimeEnvironmentSchema = z.enum(['dev', 'qa', 'uat', 'production']);

const envSchema = z.looseObject({
  VITE_BACKEND_URL: z.url(),
  VITE_ENVIRONMENT: runtimeEnvironmentSchema.default('production'),
  VITE_LOGROCKET_ENABLED: z.string().optional(),
  VITE_LOGROCKET_APPID: z.string().optional(),
  VITE_LOGROCKET_LOG_TEST: z.string().optional(),
  VITE_DEFAULT_COUNTRY: z.string().optional().default('US'),
  VITE_DEFAULT_PRIMARY_LANGUAGE: z.string().optional().default('en'),
  VITE_LANDING_URL: z.string().optional(),
  VITE_CUSTOMER_SUPPORT_EMAIL: z.string().optional(),
  VITE_CONTACT_PHONE: z.string().optional(),
  VITE_PHONE_NUMBER_COUNTRY_CODE: z.string().optional().default('+1'),
  VITE_MINIMUM_AGE: z.string().optional().default('18'),
  VITE_LOG_LEVEL: z.string().optional().default('info'),
  VITE_AZURE_CLIENT_ID: z.string().optional(),
  VITE_AZURE_AUTHORITY: z.string().optional(),
  VITE_AZURE_KNOWN_AUDIENCE: z.string().optional(),
  VITE_AZURE_TENANT_NAME: z.string().optional(),
  VITE_BEXA_CLINICAL_SERVICES_URL: z.string().optional(),
  VITE_ONSCHED_CLIENT_ID: z.string().optional(),
  VITE_ONSCHED_ENV: z.string().optional(),
  VITE_TTL_ONBOARDING_DATA_IN_HOURS: z.string().optional(),
  VITE_SUPPORTED_TIMEZONES: z.string().optional(),
});

export type Env = z.infer<typeof envSchema>;

export const validateEnv = (): Env => {
  try {
    return envSchema.parse(import.meta.env);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const issues = error.issues
        .map((issue) => `${issue.path.join('.')}: ${issue.message}`)
        .join('\n');
      // eslint-disable-next-line no-console
      console.error(`❌ Invalid environment variables:\n${issues}`);

      if (import.meta.env.PROD) {
        // In production, we might want to fail fast or just log
        // throw new Error('Invalid environment variables');
      }
    }
    return import.meta.env as unknown as Env;
  }
};

export const env = validateEnv();
